import { CampaignuiBaseColumn } from '@bingads-webui-campaign/campaignui-base-column';

import { InlineEditableColumnPrompt } from '../../inline-editable/prompt';
import template from './negative-keyword.pug';
import { getSchema, patchParentObj } from '../../inline-editable/inline-edit-schema';

export class NegativeKeywordColumn extends CampaignuiBaseColumn {
  constructor({ i18n, view }) {
    const title = i18n.getString('ColumnName_NegativeKeywords_FullName');

    super({
      name: 'NegativeKeyword',
      property: ['Id', 'Text'],
      title,
      sortable: 'Text',
      editable: true,
      type: 'string',
      helpId: 'Page_CampaignGrids_NegKeywords',
      helpAriaLabel: i18n.getString('Click to learn more about {{item}}', { item: title }),
    });

    this.i18n = i18n;
    this.view = view;
  }

  pickProperty(item) {
    const {
      Text: text,
    } = item;

    return {
      text,
    };
  }

  onPrompt({ position, item }) {
    InlineEditableColumnPrompt({
      position,
      item: patchParentObj(item),
      view: this.view,
      i18n: this.i18n,
      fieldName: 'Text',
      customSchema: getSchema('campaign'),
    });
  }

  template({ value }) {
    return template({ value });
  }
}
